import Image from 'next/image';
import { FormattedMessage, useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Button from '@alltrails/denali/components/Button';
import plpLogo from './AllTrailsPublicLandsProgram-Logo-Neon-Light.svg';
import styles from './GivingBack.module.scss';
import givingBackImage from './one-percent-logo-en.svg';

const GivingBack = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.heading}>
          <Typography component="h2" variant="heading500" mb="8" color="inverse" className={styles.title}>
            <FormattedMessage defaultMessage="Our impact" />
          </Typography>
          <Typography component="div" variant="text300" color="inverse" className={styles.subtitle}>
            <FormattedMessage defaultMessage="We're committed to protecting public lands, minimizing our environmental impact, and enabling safe access to the outdoors for everyone." />
          </Typography>
        </div>
        <div className={styles.impactColumns}>
          <div className={styles.impactCard}>
            <div className={styles.logoContainer}>
              <a href="https://directories.onepercentfortheplanet.org/profile/alltrails-inc" target="_blank" rel="noreferrer">
                <Image
                  width={258}
                  height={123}
                  alt={intl.formatMessage({ defaultMessage: '1% for the Planet' })}
                  src={givingBackImage}
                  className={styles.onePercentLogo}
                  loading="lazy"
                />
              </a>
            </div>
            <Typography component="div" variant="text300" color="inverse" className={styles.cardText}>
              <FormattedMessage defaultMessage="We put our money where the trails are. As a proud 1% for the Planet company, we partner with nonprofits that work to protect trails, expand safe access to the outdoors, and preserve the places we love." />
            </Typography>
            <Button
              variant="inverse"
              size="md"
              className={styles.ctaButton}
              text={intl.formatMessage({ defaultMessage: 'Read our latest news' })}
              linkInfo={{
                href: '/newsroom',
                target: '_blank'
              }}
            />
          </div>
          <div className={styles.impactCard}>
            <div className={styles.logoContainer}>
              <Image
                width={1567}
                height={116}
                alt={intl.formatMessage({ defaultMessage: 'AllTrails Public Lands Program' })}
                src={plpLogo}
                loading="lazy"
              />
            </div>
            <Typography component="div" variant="text300" color="inverse" className={styles.cardText}>
              <FormattedMessage defaultMessage="We created the Public Lands Program to give land managers free, real-time trail data and insights. Together, we're helping everyone enjoy and explore the outdoors safely and responsibly." />
            </Typography>
            <Button
              variant="inverse"
              size="md"
              className={styles.ctaButton}
              text={intl.formatMessage({ defaultMessage: 'Learn more' })}
              linkInfo={{
                href: 'https://publiclands.alltrails.com/',
                target: '_blank'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GivingBack;
